module.exports = __webpack_public_path__ + "img/AccuLV.fa00523c.png";